module.exports = __webpack_public_path__ + "static/media/taxida_black.5b9fa14b.svg";